import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'whatwg-fetch';

import RankingCommercial from './rankingCommercial';
import RankingSupport from './support/rankingStatSupport';
import SupportCustomerRatingRanking from 'src/scenes/Rankings/scenes/Support/scenes/CustomerRatingRanking';
import CommercialCustomerRatingRanking from 'src/scenes/Rankings/scenes/Commercial/scenes/CustomerRatingRanking';

export default class AppRankings extends React.Component {
  render() {
    return (
      <div id='appView' className='div-entity'>
        <div id='appViewContent'>
          <Switch>
            <Route
              exact
              path={`${this.props.match.url}/commercial/telecom`}
              render={() => <RankingCommercial domain='telecom' />}
            />

            <Route
              exact
              path={`${this.props.match.url}/commercial/informatique`}
              render={() => <RankingCommercial domain='informatique' />}
            />

            <Route
              exact
              path={`${this.props.match.url}/commercial/customer-ratings`}
              render={() => <CommercialCustomerRatingRanking />}
            />

            <Route exact path={`${this.props.match.url}/support/tickets`} render={() => <RankingSupport />} />

            <Route
              exact
              path={`${this.props.match.url}/support/customer-ratings`}
              render={() => <SupportCustomerRatingRanking />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
